// src/routes/AccountantRoutes.tsx
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';
import accountantRoutesConfig from './config/accountantsConfig';


const AccountantRoutes= accountantRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}> 
          <ProtectedRoute element={<Component />} allowedRoles={['Accountant', 'Admin']} />
      </Suspense>
    }
  />
));
export default AccountantRoutes;

